import { render, staticRenderFns } from "./AddNewness.vue?vue&type=template&id=690e2254&"
import script from "./AddNewness.vue?vue&type=script&lang=js&"
export * from "./AddNewness.vue?vue&type=script&lang=js&"
import style0 from "./AddNewness.vue?vue&type=style&index=0&id=690e2254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports